<template>
<div class="randomizer-tasklist-order">
  <p class="randomizer-tasklist-order_message white-text-20">
    {{
      $c('Чтобы увидеть доступные задания, привяжи свою карту Tanks Blitz или закажи карту, если у тебя её пока нет.')
    }}
  </p>
  <a @click="$root.$emit('randomRewardsBindCard')" class="button contained">{{ $c('Привязать карту') }}</a>
  <a :href="orderLink" class="button outlined ml20">{{ $c('Заказать карту') }}</a>
</div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { getOrderUrl } from '@/helpers'
import { State } from 'vuex-class'

@Component({
  components: {}
})
class OrderOrBind extends Vue {
  @State('country') currentCountry
  @State('randomButtonData') randomButtonData
  get orderLink () {
    return getOrderUrl(this.currentCountry, this.randomButtonData.game)
  }
}

export default OrderOrBind
</script>

<style lang="scss" scoped>
  .randomizer-tasklist-order {
    display: block;
    &_message {
      margin-bottom: 47px;
    }
    .button {
      width: 100%;
      box-sizing: border-box;
      margin-left: 0;
      margin-top: 16px;
      @include media_desktop {
        width: auto;
        margin-left: auto;
        margin-top: 0;
        &.ml20 {
          margin-left: 20px;
        }
      }
      &:first-of-type {
        margin-top: 0;
      }
    }
  }
</style>
